import { cn } from '@/lib/utils'

type GoldBorderGradientProps = {
  className?: string
}

const GoldBorderGradient = ({ className }: GoldBorderGradientProps) => {
  return (
    <div
      className={cn('pointer-events-none absolute inset-0', className)}
      style={{
        background: `linear-gradient(360deg, rgba(255, 107, 0, 0) 64.97%, rgba(255, 225, 67, 0.5) 117.36%), linear-gradient(180deg, rgba(255, 255, 255, 0.3) 1.75%, rgba(255, 225, 67, 0) 20.06%)`,
        mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
        maskComposite: 'exclude',
        padding: '1px',
      }}
    />
  )
}

export default GoldBorderGradient
